/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$(document).ready(function(){
  
  swapDivs();
  $( window ).resize(function() {
    swapDivs();
  });
  $(window).scroll(function () {
    checkHeader();
  });

  /*
  var container = $(".SubMenu__List");
  var arrows = $(".Menu__TitleArrow");
  
  $(".MegaMenu__Title").hover(function () {
    var id = $(this).attr("id");
    container.html("").hide();
    arrows.hide();

    $(".MegaMenu__Title").removeClass("in-hover").children("span.Menu__TitleArrow").hide();
    $(".MegaMenu__Image").hide();
    $('.MegaMenu__Images .Icon').hide();
    $(this).addClass("in-hover");
    $(this).children("span.Menu__TitleArrow").show();

    if ($(this).hasClass('SubMenu__LinkOpener')) container.html($("ul#SubMenu__"+id).html()).show();
    if ($(".MegaMenu__Image."+id).length === 1){
      $(".MegaMenu__Image."+id).show();
      $('.MegaMenu__Images .Icon').show();
    }
  });
  
  $(".Header__MainNav .HorizontalList .HorizontalList__Item").hover(function(){
    container.html("").hide();
    arrows.hide();
    $(".MegaMenu__Image").hide();
    $('.MegaMenu__Images .Icon').hide();
  });
  */

  $('.Footer__Title ').on('click',function () {
    $(this).parents('.Footer__Block').find('div.hidden-phone, ul.hidden-phone').stop(true).toggleClass('show');
  });

  $(".OpenSelectorLanguage").click(function(){
    $(".Drawer__Close").click();
    $(".LanguageSelector").click();
  });
  
  // listen to drawer cart updates
  $(document).on('click', '.Drawer__Container .QuantitySelector__Button', function() {
    
    console.log('*** change');
    
    if ( $(this).hasClass('Qty-minus') ) {
      
      console.log('*** minus');
      updateMiniCartCount('minus');
      
    }
    
    if ( $(this).hasClass('Qty-plus') ) {
      
      console.log('*** plus');
      updateMiniCartCount('plus');
      
    }
  
  });
  
  // listen to drawer cart item remove
  $(document).on('click', '.Drawer__Container .CartItem__Remove', function() {
    
    var item_curr_qty = $(this).parents('.CartItem__Actions').find('.QuantitySelector__CurrentQuantity').val();
    
    console.log('*** remove', item_curr_qty);
    
    var item_count = $(".Header__CartDot").html();
    
    item_count = item_count - item_curr_qty;
    
    $(".Header__CartDot").html(item_count);
    
  });

});

function bindAddToCart(){
  if($(".ProductForm__AddToCart:not(.binded)").length > 0){
    $(".ProductForm__AddToCart:not(.binded)").click(function(e){
      
      console.log('*** add');
      
      $('html').addClass('add-cart-loading');
      $('.PageOverlay').addClass('is-visible');
      
      $(".ProductForm__AddToCart").addClass('binded');
      e.preventDefault();
      e.stopPropagation(); 
      $(this).prop('disabled', true);
      $(this).addClass('hide');
      $(".spinner").addClass('show');
      const items = $(this).parent('form').serialize();
      addProducts(items);
      $(this).prop('disabled', false);
      
    });
  }
}
bindAddToCart(); 

function addProducts(items){
  if (items.length > 0) {
    $.post(routes.cartAddUrl, items)
      .fail(function(error){
        //let response_error = getError(error.responseText);
        //alert(response_error);
        $(".ProductForm__AddToCart").removeClass('hide');
        $(".spinner").removeClass('show');
      
      	$('html').removeClass('add-cart-loading');
      	
      	console.log('*** error add:', error);
      
      })
      .done(function (data) {
        $.get(routes.cartUrl + '?view=drawer').done(function(response){
          updateCartCount();
          updateCartDrawerContent(response);
          $(".ProductForm__AddToCart").removeClass('hide');
          $(".spinner").removeClass('show');
          
          $('html').removeClass('add-cart-loading');
          
          console.log('*** end add');
          
          updateMiniCartCount('plus');
          
        });
      });
  } else {
    alert("Errore caricamento prodotti");
  }
}

function updateCartDrawerContent(data){  
  let tempElement = document.createElement('div');
  tempElement.innerHTML = data;
  let responses = tempElement.querySelectorAll('.Drawer__Content');
  //$('.Cart.Drawer__Content').html(responses);
  
  //console.log('****', $(data).find('.Cart.Drawer__Content'));
  
  $('.Cart.Drawer__Content').html( $(data).find('.Cart.Drawer__Content').html() );
  
}

function updateCartCount(){  
  $(".Header__CartDot").addClass('is-visible');
  $(".Header__Cart")[0].click();
}

function updateMiniCartCount(action){
  
  var item_count = $(".Header__CartDot").html(); 
  
  if (action == 'plus') item_count++;
  if (action == 'minus') item_count--;
  
  $(".Header__CartDot").html(item_count);
  
}

/***/

var pInfScrLoading = false;
var pInfScrDelay = 250;
function pInfScrExecute() {
  let pInfScrNode = $('.more').last();
  let pInfScrURL = $('.more .RoundButton').last().attr("data-url");
  if(pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
    $.ajax({
      type: 'GET',
      url: pInfScrURL,
      beforeSend: function() {
        if (pInfScrLoading) return false;
        pInfScrLoading = true;
        pInfScrNode.addClass('loading');
        pInfScrNode.children(".RoundButton").children("svg").addClass("rotate");
      },
      success: function(data) {
        // remove loading feedback
        $('.more .RoundButton').parent().remove();
        var filteredData = $(data).find(".Grid__Cell").addClass('load');
        $('.ProductList').append(filteredData);
        $(".ProductItem").each(function(){
          if ($(this).css("visibility") === "hidden") $(this).css({"display":"none","visibility":"visible"}).fadeIn(pInfScrDelay);
        });
        if($(data).find('.more').length > 0){
          $('.CollectionInner__Products').append($(data).find('.ProductListUpdate'));
        }
        $(".ProductList .Footer__Social").parent().remove();
        $(".ProductList div[class*='Footer__']").remove();
        setTimeout(function(){$(".Grid__Cell").removeClass('load').addClass('loaded');}, 200);
        pInfScrLoading = false;
        $('.top').show();
        bindAddToCart();
      },
      dataType: "html"
    });
  }
}

$.fn.swap = function (elem) {
  elem = elem.jquery ? elem : $(elem);
  return this.each(function () {
    $(document.createTextNode('')).insertBefore(this).before(elem.before(this)).remove();
  });
};

function swapDivs(){
  let isMobile = window.matchMedia("only screen and (max-width: 600px)").matches;

  if (isMobile) {

    $('.one_swap').swap('.two_swap');
    $('.Footer__Copyright').insertAfter('.Footer__Policy');
    $('.one_swap').insertAfter('.two_swap');
  }
}


function checkHeader(){
  var pos = $(window).scrollTop();
  if( pos >100 ){
    $('.template-product').find('#section-header').css({
      'background-color': '#fff',
      'border-bottom': '1px solid #e5e5e5'
    });
  }else{
    $('.template-product #section-header').css({
      'background-color': 'transparent',
      'border-bottom': '0px'
    });
  }
  
  if (pos > 115) {
    $("#sidebar-cart").css({
      'top': '75px',
      'height': 'calc(100vh - 75px)'
    });
  } else {
    $("#sidebar-cart").css({
      'top': '115px',
      'height': 'calc(100vh - 115px)'
    });
  }
}

if(window.location.pathname === "/" || window.location.pathname === "/it" || window.location.pathname === "/fr" || window.location.pathname === "/de") {
  $(window).scroll(function () {
    if($(window).scrollTop() > $("#shopify-section-announcement").height()) {
      $(".Header__Wrapper")[0].style.position = "fixed";
      $(".Header__Wrapper")[0].style.top = "0";
      $(".Header__Wrapper")[0].style.background = "white";
      $(".Header__Wrapper")[0].style.width = "100%";
      $("#main")[0].style.marginTop = String($("#shopify-section-announcement").height() * 2 + 10) + "px";
    } else {
      $(".Header__Wrapper")[0].style.position = "initial";
      $(".Header__Wrapper")[0].style.top = "initial";
      $(".Header__Wrapper")[0].style.background = "initial";
      $(".Header__Wrapper")[0].style.width = "initial";
      $("#main")[0].style.marginTop = "0";
    }
  });
}

if(window.location.pathname.indexOf("who-we-are-our-story") !== -1 || window.location.pathname.indexOf("how-we-work") !== -1 || window.location.pathname.indexOf("our-mission") !== -1 || window.location.pathname.indexOf("account") !== -1 || window.location.pathname.indexOf("store-locator") !== -1) {
  document.getElementById("shopify-section-newsletter").style.display = "none";
}
/*
$("#NewMenuBtn").click(function() {
  document.getElementById("NewMenu").classList.add("Out");
  document.getElementsByClassName("PageOverlay")[0].classList.add("is-visible");
  document.getElementsByTagName("html")[0].classList.add("no-scroll");
  document.getElementById("sidebar-cart").setAttribute("aria-hidden", "true");
});

$("#NewMenuClose").click(function() {
  document.getElementById("NewMenu").classList.remove("Out");
  document.getElementsByClassName("PageOverlay")[0].classList.remove("is-visible");
  document.getElementsByTagName("html")[0].classList.remove("no-scroll");
});

document.getElementsByClassName("PageOverlay")[0].addEventListener("click", function() {
  document.getElementById("NewMenu").classList.remove("Out");
  document.getElementsByClassName("PageOverlay")[0].classList.remove("is-visible");
  document.getElementsByTagName("html")[0].classList.remove("no-scroll");
});

document.getElementsByClassName("Header__Cart")[0].addEventListener("click", function() {
  document.getElementById("NewMenu").classList.remove("Out");
});
*/